var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Vue from 'vue';
import './MtLangSelect.css';
export default Vue.extend({
    name: 'MtLangSelect',
    props: {
        current: {
            type: String,
            required: true,
        },
        languages: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
        },
    },
    computed: {
        _languages: function () {
            var _this = this;
            return Object.entries(this.languages).reduce(function (prev, _a) {
                var _b;
                var lang = _a[0], value = _a[1];
                if (lang === _this.current || !value.name) {
                    return prev;
                }
                return __assign(__assign({}, prev), (_b = {}, _b[lang] = value.name, _b));
            }, {});
        },
    },
    methods: {
        generateTitle: function () {
            return this.$createElement('p', { staticClass: 'mt-lang-select__title' }, [this.title]);
        },
        generateFlag: function (lang) {
            return this.$createElement('img', {
                class: 'mt-lang-select__flag',
                attrs: {
                    src: require("./flags/" + lang + ".svg"),
                    alt: '',
                },
            });
        },
        generateContent: function () {
            var _this = this;
            return Object.entries(this._languages).reduce(function (prev, _a) {
                var lang = _a[0], value = _a[1];
                var Left = _this.$createElement('div', { staticClass: 'mt-lang-select__left' }, [value]);
                var Right = _this.$createElement('div', { staticClass: 'mt-lang-select__right' }, [_this.generateFlag(lang)]);
                return __spreadArray(__spreadArray([], prev), [
                    _this.$createElement('div', {
                        key: lang,
                        staticClass: 'mt-lang-select__option',
                        on: {
                            click: function () { return _this.$emit('change', lang); },
                        },
                    }, [Left, Right]),
                ]);
            }, []);
        },
    },
    render: function (h) {
        return h('div', { staticClass: 'mt-lang-select' }, [
            this.generateTitle(),
            this.generateContent(),
        ]);
    },
});
//# sourceMappingURL=MtLangSelect.js.map